import React, { Component, Fragment } from 'react';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import ReduxThunk from 'redux-thunk';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/lib/integration/react';
import NotificationsSystem from 'reapop';
import ReactGA from 'react-ga';
import theme from 'reapop-theme-wybo';
import '../index.scss';

const trackingId = "UA-148876543-1"; // Replace with your Google Analytics tracking ID
ReactGA.initialize(trackingId);

/**
 * Import components
 */

// import Authentication from './components/Authentication';
import Loader from 'components/Loading/Loader';
import RootReducer from 'reducers';


/**
 * Define Redux middleware
 */

export const history = createHistory();

// Initialize google analytics page view tracking
history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
});

const middleware = [
    ReduxThunk,
    routerMiddleware(history)
];

/**
 * Activate a logger when on development environments
 */

if (process.env.NODE_ENV !== 'production') {
    middleware.push(require('redux-logger').createLogger());
}

/**
 * Create new Redux store
 */

const store = createStore(
    RootReducer,
    applyMiddleware(...middleware)
);

export const persistor = persistStore(store);

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <PersistGate persistor={persistor} loading={<Loader />}>
                    <ConnectedRouter history={history}>
                        <Fragment>
                            {this.props.children}
                            <NotificationsSystem theme={theme}/>
                        </Fragment>
                    </ConnectedRouter>
                </PersistGate>
            </Provider>
        );
    }
}

export default App;